module.exports = __webpack_public_path__ + "img/img18.5146a78b.png";